import React from "react";
import styled from "styled-components";
import { SORT_ORDER } from "../../../models/Sorting";

interface SortIconProps {
	sortType?: SORT_ORDER;
}

const SortIcon: React.FC<SortIconProps> = ({ sortType = SORT_ORDER.DEFAULT }) => {
	switch (sortType) {
		case SORT_ORDER.ASC:
			return <SortIconStyles src="/svg/sorting-arrow-down.svg" />;
		case SORT_ORDER.DESC:
			return <DescSortIconStyles src="/svg/sorting-arrow-down.svg" />;
		default:
			return <SortIconStyles src="/svg/sorting-arrow-default.svg" />;
	}
};

export default SortIcon;

const SortIconStyles = styled.img`
	margin: 0 0.5rem;
	cursor: pointer;
`;

const DescSortIconStyles = styled(SortIconStyles)`
	-ms-transform: rotate(180deg);
	transform: rotate(180deg);
`;
